import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import LdapTestConnectionButton from './ldapTestConnectionButton';

@inject('translationsStore') @observer
export default class LdapTestConnectionButtonContainer extends Component {

    render() {

        const translations = {
            recheck: this.props.translationsStore.translate('RECHECK'),           
        };

        return(
            <LdapTestConnectionButton 
                label={this.props.label}
                translations={translations} 
                performTestConnection={this.props.performTestConnection} 
                isInProgress={this.props.currentLdapStore.testLDAPServerProgress}
                isTestSuccessful={this.props.currentLdapStore.testLDAPServerResult} 
                testMessage={this.props.currentLdapStore.testLDAPServerMessage} 
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ldap/ldapTestConnectionButtonContainer/index.jsx